module.exports = __webpack_public_path__ + "static/media/mob-greyhound.d7162cfa.webp";